"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = instrument;

function instrument(window, requirejs, queryUtil, editorModel) {
  editorModel = editorModel || {};
  var editorVersion = editorModel.editorVersion;
  var base = (window.serviceTopology.biServerUrl || 'http://frog.wix.com').replace(/\/$/, '');
  var suppressbi = queryUtil.isParameterTrue('suppressbi');
  var isDebug = queryUtil.getParameterByName('debug');

  var storage = function () {
    // TODO replace with storage utils
    try {
      var s = window.sessionStorage;
      var test = "ep".concat(Date.now());
      s.setItem(test, test);

      if (s.getItem(test) === test) {
        s.removeItem(test);
        return s;
      }
    } catch (e) {
      var data = {};
      return {
        setItem: function setItem(k, v) {
          data[k] = v;
        },
        getItem: function getItem(k) {
          return data[k];
        },
        removeItem: function removeItem(k) {
          delete data[k];
        }
      };
    }
  }();

  if (window.isPrefetchMode) {
    storage.setItem('afterEditorPrefetch', 'true');
  } else {
    window.afterEditorPrefetch = !!storage.getItem('afterEditorPrefetch');
    storage.removeItem('afterEditorPrefetch');
  }

  var performance = window.performance;

  if (performance && performance.mark) {
    if (performance.setResourceTimingBufferSize) {
      if ('onresourcetimingbufferfull' in performance) {
        performance.onresourcetimingbufferfull = function () {
          var maxSize = 150;
          return function () {
            maxSize *= 2;
            performance.setResourceTimingBufferSize(maxSize);
          };
        }();
      } else {
        performance.setResourceTimingBufferSize(isDebug ? 1000 : 300);
      }
    }

    performance.mark('main-r loaded');
  }

  function getCookie(name) {
    var re = new RegExp("(?:^|\\W)".concat(name, "s*=([^;]*)"));
    var m = window.document.cookie.match(re);
    return m ? m[1].trim() : m;
  }

  var permissionInfo = editorModel.permissionsInfo || {};

  var implicitParams = function () {
    var implicitFields = {
      ownerId: function ownerId() {
        return permissionInfo.ownerId || '';
      },
      roles: function roles() {
        var loggedInUserRoles = (permissionInfo.loggedInUserRoles || []).map(function (loggedInUserRole) {
          return loggedInUserRole.role;
        }).join();

        this.roles = function () {
          return loggedInUserRoles;
        };

        return this.roles();
      },
      esi: function esi() {
        return editorModel.editorSessionId || '';
      },
      did: function did() {
        return window.siteId || '';
      },
      msid: function msid() {
        return editorModel.metaSiteId || '';
      },
      ts: function ts(now) {
        return now - (window.mainLoaded || 0);
      },
      c: function c(now) {
        return now;
      }
    };
    var newrelic = window.newrelic;

    if (newrelic) {
      if (newrelic.setCustomAttribute) {
        newrelic.setPageViewName(window.location.href.replace(/^[^/]*\/\//, ''));
        var roles = implicitFields.roles();

        if (roles) {
          newrelic.setCustomAttribute('roles', roles);
        }

        newrelic.setCustomAttribute('esi', implicitFields.esi());
        newrelic.setCustomAttribute('did', implicitFields.did());
        newrelic.setCustomAttribute('msid', implicitFields.msid());
        newrelic.setCustomAttribute('prefetch', window.afterEditorPrefetch);

        if (editorVersion) {
          newrelic.setCustomAttribute('editorVersion', editorVersion);
        } // Running experiments:


        var runningExperiments = editorModel.runningExperiments;

        if (runningExperiments) {
          var runningExperimentKeys = Object.keys(runningExperiments).filter(function (key) {
            return runningExperiments[key] !== 'old';
          }).map(function (experimentName) {
            var experimentValue = runningExperiments[experimentName];
            return experimentValue !== 'new' ? experimentName + '=' + experimentValue : experimentName; //eslint-disable-line prefer-template
          }).join('][');

          if (runningExperimentKeys) {
            newrelic.setCustomAttribute('experiments', "[".concat(runningExperimentKeys, "]"));
          }
        }
      }

      if (!suppressbi && editorVersion && newrelic.addPageAction) {
        newrelic.addPageAction('main-r loaded');
      }
    }

    return function () {
      var size = 0;
      var now = Date.now();
      var payload = Object.keys(implicitFields).map(function (key) {
        var val = implicitFields[key](now);
        var result = "".concat(key, "=").concat(val);
        size += result.length;
        return result;
      });
      payload.size = size;
      return payload;
    };
  }();

  function sendBI(reportDef, params) {
    var payload = implicitParams();
    var size = payload.size;
    params = Object.keys(params || {}).map(function (key) {
      var value = params[key];

      if (typeof value === 'string') {
        if (size + value.length > 1536) {
          value = value.substring(0, Math.max(1536 - size, 32));
        }

        value = encodeURIComponent(value);
      }

      var result = "".concat(key, "=").concat(value);
      size += result.length;
      return result;
    });
    payload = params.concat(payload);
    var endpoint = reportDef.endpoint || 'editor';
    var evid = reportDef.evid;
    var src = reportDef.src || 38;
    payload = payload.length ? '&' + payload.join('&') : ''; //eslint-disable-line prefer-template

    var srcBI = "".concat(base, "/").concat(endpoint, "?evid=").concat(evid, "&src=").concat(src, "&majorVer=3&viewMode=editor").concat(payload);

    if (suppressbi) {
      window.console.log('BI:', srcBI);
    } else {
      new window.Image().src = srcBI;
    }
  }

  var bi = {
    event: function event(reportDef, params) {
      if (typeof reportDef === 'number') {
        reportDef = {
          evid: reportDef
        };
      }

      sendBI(reportDef, params);
    },
    error: function () {
      var errorSeverityMap = {
        recoverable: 10,
        warning: 20,
        error: 30,
        fatal: 40
      };
      return function (reportDef, params) {
        params = params || {};
        var rd = {
          evid: 10,
          endpoint: reportDef.endpoint || 'trg'
        };
        var p = {
          errn: reportDef.errorName,
          errc: reportDef.errorCode,
          sev: errorSeverityMap[reportDef.severity] || reportDef.severity,
          cat: 1,
          iss: 1
        };
        var ut = getCookie('userType');

        if (ut) {
          p.ut = ut;
        }

        Object.keys(params).forEach(function (param) {
          p[param] = params[param];
        });
        sendBI(rd, p);
      };
    }()
  };

  if (!window.bi) {
    window.bi = bi;
  }

  if ((isDebug || suppressbi || !editorVersion) && !queryUtil.isParameterTrue('bi')) {
    return;
  }

  var _sendErrorOnce = function sendErrorOnce(errorName, errorCode, severity) {
    //eslint-disable-line func-style
    _sendErrorOnce = function sendErrorOnce() {}; // only report one error per session


    var params = Array.prototype.slice.call(arguments, 3).reduce(function (result, arg, index) {
      result['p' + (index + 1)] = arg; //eslint-disable-line prefer-template

      return result;
    }, {});
    bi.error({
      errorName: errorName,
      errorCode: errorCode,
      severity: severity
    }, params);
  };

  var onerror = window.onerror;

  window.onerror = function (errorMsg, url, line, column, err) {
    var where = err && err.stack ? "".concat(err.stack) : url;
    var href = window.location.href;

    _sendErrorOnce('JAVASCRIPT_ERROR', 111022, 'fatal', errorMsg, where, href); // JAVASCRIPT_ERROR from packages/core/src/main/bi/errors.js


    if (onerror) {
      return onerror.apply(this, arguments);
    }
  };

  if (window.console) {
    var _console = console,
        error = _console.error;

    if (error) {
      console.error = function () {
        var href = window.location.href;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _sendErrorOnce.apply(void 0, ['CONSOLE_ERROR', 111023, 'error', href].concat(args)); // CONSOLE_ERROR from packages/core/src/main/bi/errors.js


        return error.apply(this, args);
      };
    }
  }

  requirejs.onError = function (err) {
    // because ajv requires js-beautify synchronously even if does not use
    if (err.message && err.message.indexOf && err.message.indexOf('Module name "js-beautify" has not been loaded yet') === 0) {
      return;
    }

    var _err$requireModules = err.requireModules,
        requireModules = _err$requireModules === void 0 ? [] : _err$requireModules,
        message = err.message,
        stack = err.stack,
        _err$errn = err.errn,
        errn = _err$errn === void 0 ? 'REQUIREJS_ERROR' : _err$errn,
        _err$errc = err.errc,
        errc = _err$errc === void 0 ? 111024 : _err$errc,
        _err$severity = err.severity,
        severity = _err$severity === void 0 ? 'fatal' : _err$severity,
        requireType = err.requireType;
    var modules = requireModules.join(';');
    var what = stack ? '' + stack : message; //eslint-disable-line prefer-template

    var href = window.location.href;

    _sendErrorOnce(errn, errc, severity, what, modules, href, requireType); // REQUIREJS_ERROR from packages/core/src/main/bi/errors.js

  };
}
//# sourceMappingURL=instrument.js.map